import { createSlice } from '@reduxjs/toolkit';

export const utilSlice = createSlice({
	name: 'header',
	initialState: {
		update: false, // Trigger to update a component instead of "useNavigate"
		tempData: undefined, // Store temp data to share between components
	},
	reducers: {
		setUpdate: (state, action) => {
			state.update = action.payload.update;
		},
		setTempData: (state, action) => {
			state.tempData = action.payload.tempData;
		},
	},
});

export const { setUpdate, setTempData } = utilSlice.actions;

export default utilSlice.reducer;
